// src/App.js
// import MobileControls from "./pages/MobileControls";
import { useState, useEffect } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { TokenProvider } from "./components/TokenContext";


import BookingSuccess from "./pages/BookingSuccess";
import PaymentCancelled from "./pages/PaymentCancelled";
import PaymentFailed from "./pages/PaymentFailed";
import SearchForm from "./pages/SearchForm";
import Results from "./pages/Results";

import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import ScrollToTop from "./components/ScrollToTop";

import PackageDetails from "./pages/PackageDetails";
import PackagePage from "./pages/PackagePage";

import AllApartmentPage from "./pages/AllApartmentPage";
import AllApartmentDetails from "./pages/AllApartmentDetails";

import AboutUs from "./pages/AboutUs";
import CancellationPolicy from "./pages/CancellationPolicy";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DeleteAccountPage from "./pages/DeleteAccount";





function App() {
  return (
    <TokenProvider>
      <BrowserRouter>
        <ScrollToTop />
        {/* <Navbar /> */}
           <SearchForm/>

        {/* ROUTES */}
        {/* <div className="pt-32"> */}
        <div className="pt-32 sm:pt-24 md:pt-0 pb-20 bg-white">
          <Routes>
            {/* <Route path="/" element={<Dashboard />} /> */}
            <Route path="/" element={<AllApartmentPage />} />
            <Route path="/packages" element={<PackagePage />} />
             <Route path="/packages/:slug" element={<PackageDetails />} />
            <Route path="*" element={<div className="p-8">404 Not Found</div>} />
            <Route path="/booking-success" element={<BookingSuccess />} />
            <Route path="/payment-cancelled" element={<PaymentCancelled />} />
            <Route path="/payment-failed" element={<PaymentFailed />} />

             <Route path="/results" element={<Results />} />

            <Route path="/apartments" element={<AllApartmentPage />} />
            <Route path="/apartments/:slug" element={<AllApartmentDetails />} />

            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/cancellation-policy" element={<CancellationPolicy />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
            <Route path="/delete-account" element={<DeleteAccountPage/>}/>


          </Routes>
         {/* ✅ Global Mobile Bottom Bar (Mobile Only) */}
        <ChatWidget />
        </div>
        <Footer/>
      </BrowserRouter>
    </TokenProvider>
  );
}

export default App;
